import { render, staticRenderFns } from "./InstitutionCharges.vue?vue&type=template&id=4d2235c5&scoped=true"
import script from "./InstitutionCharges.vue?vue&type=script&lang=js"
export * from "./InstitutionCharges.vue?vue&type=script&lang=js"
import style0 from "./InstitutionCharges.vue?vue&type=style&index=0&id=4d2235c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2235c5",
  null
  
)

export default component.exports